import processInput from 'apps/web/utils/formInput';

import { LC_PAGE_SUBJECT_CHAR_LIMIT } from '@lessonPlanner/constants';

import { TextAreaField, TextField } from '../form-fields';
import TopicsSection from '../organisms/TopicsSection';
import {
  FrameworkDropdown,
  GradeLevelDropdown,
  StateDropdown,
} from '../Select';

import FORM_KEYS from '../../constants/forms/summative-test/formKeys';

export default function AmericanST({
  errors,
  watchedValues,
  setValue,
  topicsList,
  triggerValidation,
}: {
  errors;
  watchedValues;
  setValue;
  formState;
  topicsList;
  triggerValidation;
}) {
  const {
    subject,
    curriculumFramework,
    topics = [],
    gradeLevel,
  } = watchedValues;

  async function updateFieldValue(fieldName, value) {
    setValue(fieldName, value);
  }

  return (
    <>
      <FrameworkDropdown
        error={!!errors.curriculumFramework}
        label="Curriculum Framework"
        value={curriculumFramework}
        errorMessage={
          !!errors.curriculumFramework && 'Please select a Framework'
        }
        onBlur={() => {
          triggerValidation(FORM_KEYS.curriculumFramework);
        }}
        onChange={(value) =>
          updateFieldValue(FORM_KEYS.curriculumFramework, value)
        }
      />
      <TextField
        className="col-span-full"
        errorMessage={!!errors.subject && 'Please enter the Subject'}
        id="subject"
        isMaxLengthReached={subject?.length >= LC_PAGE_SUBJECT_CHAR_LIMIT}
        label="Subject"
        maxLength={LC_PAGE_SUBJECT_CHAR_LIMIT}
        name="subject"
        placeholder={'ex. Science, Music, etc.'}
        type="subject"
        value={subject}
        onBlur={() => {
          processInput(
            updateFieldValue,
            (field) => topicsList.triggerGradualValidation(field),
            'subject',
            subject?.trim() || '',
          );
        }}
        onChange={(e) => {
          processInput(
            updateFieldValue,
            (field) => topicsList.triggerGradualValidation(field),
            'subject',
            e.target.value,
          );
        }}
      />
      <StateDropdown
        error={errors.specificStandards}
        label="State Standard"
        value={watchedValues.specificStandards}
        errorMessage={
          !!errors.specificStandards && 'Please select a State Standard'
        }
        onChange={(value) => updateFieldValue('specificStandards', value)}
        onBlur={() => {
          triggerValidation('specificStandards');
        }}
      />

      <TextAreaField
        className="col-span-full"
        id={FORM_KEYS.strategies}
        label="Assessment Strategies (Optional)"
        maxLength={LC_PAGE_SUBJECT_CHAR_LIMIT}
        name="strategies"
        placeholder="Input what assessment to prioritize"
        type="strategies"
        value={watchedValues.strategies}
        isMaxLengthReached={
          watchedValues.strategies?.length >= LC_PAGE_SUBJECT_CHAR_LIMIT
        }
        onBlur={() => {
          processInput(
            updateFieldValue,
            triggerValidation,
            FORM_KEYS.strategies,
            watchedValues.strategies?.trim() || '',
          );
        }}
        onChange={(e) => {
          processInput(
            updateFieldValue,
            triggerValidation,
            FORM_KEYS.strategies,
            e.target.value,
          );
        }}
      />

      <GradeLevelDropdown
        error={!!errors.gradeLevel}
        errorMessage={!!errors.gradeLevel && 'Please select the Grade Level'}
        value={gradeLevel}
        onBlur={() => topicsList.triggerGradualValidation(FORM_KEYS.gradeLevel)}
        onChange={(value) => updateFieldValue(FORM_KEYS.gradeLevel, value)}
      />

      <TopicsSection
        addSubtopic={topicsList.addSubtopic}
        addTopic={topicsList.addTopic}
        emptySubtopicsIndex={topicsList.emptySubtopicsIndex}
        errors={errors}
        handleSubtopicChange={topicsList.handleSubtopicChange}
        handleTrimUpdate={topicsList.handleTrimUpdate}
        isTopicEmpty={topicsList.isTopicEmpty}
        removeSubtopic={topicsList.removeSubtopic}
        removeTopic={topicsList.removeTopic}
        showSubtopics={topicsList.showSubtopics}
        toggleSubtopicsVisibility={topicsList.toggleSubtopicsVisibility}
        topics={topics}
        handleTopicChange={(topicIndex, value) => {
          topicsList.handleTopicChange(topicIndex, value);
          topicsList.debouncedValidation('topics');
        }}
      />
    </>
  );
}
